import { PermissionModel, UnknownError } from 'symbols';


export class LoadUserRoles {
  static type = `[Access] ${LoadUserRoles.name}`;
}


export class LoadUserRolesSuccess {
  static type = `[Access] ${LoadUserRolesSuccess.name}`;

  constructor(public roles: PermissionModel[]) {
  }
}


export class LoadUserRolesFail {
  static type = `[Access] ${LoadUserRolesFail.name}`;

  constructor(public error: UnknownError) {
  }
}
